import { Col, Row, Text } from 'components';
import { isToday, isYesterday } from 'date-fns';
import { formatLocale, getRound } from 'lib';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ProgressBadge, Score } from './';

const UserAvatar = styled.div`
  width: 55px;
  height: 55px;
  border-radius: 55px;
  margin-bottom: 13px;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

const GameInfo = ({ eventObject }) => {
  const { location, score, gameStatus, status, progress, home, dataInfo, away, sport } =
      eventObject,
    { t } = useTranslation(),
    date = new Date(eventObject.date),
    round = getRound(eventObject.round, dataInfo.leagueId);

  return (
    <Col wid="358px" center noFlex>
      <Col center>
        <Text col="#000" b2 center>
          {!isNaN(round) ? t('games.matchday', { round }) : t(`games.${round}`)}
        </Text>

        <Text col="#000" b2 center>
          {location}
        </Text>
      </Col>

      <Row between marg="24px 0 0">
        <Col noFlex centerAll wid="130px">
          <UserAvatar src={home.avatar} />

          <Text wid="100%" center col="#000" bold>
            {home.name}
          </Text>
        </Col>

        <Col centerAll>
          {['live', 'finished'].includes(status) ? (
            <Score score={score} sport={sport} />
          ) : (
            <Col center marg="0 0 13px" ht="55px">
              <Text col="#000" med marg="0 0 2px" center>
                {isToday(date)
                  ? t('common.today')
                  : isYesterday(date)
                    ? t('common.yesterday')
                    : formatLocale(date, 'MMM dd, iii')}
              </Text>

              <Text col="#000" med>
                {formatLocale(date, 'h:mm aa')}
              </Text>
            </Col>
          )}

          <Row noFlex ht="22px">
            <ProgressBadge
              status={status}
              gameStatus={gameStatus}
              progress={progress}
              sport={sport}
            />
          </Row>
        </Col>

        <Col noFlex centerAll wid="130px">
          <UserAvatar src={away.avatar} />

          <Text wid="130px" center col="#000" bold>
            {away.name}
          </Text>
        </Col>
      </Row>
    </Col>
  );
};

export default GameInfo;
